import { Form } from "formik";
import * as Yup from "yup";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import FormikForm from "../../../commons/formik/formikForm";
import FormikTextField from "../../../commons/formik/formikTextField";
import { StyledForm } from "../../../styled/form";
import { StyledPaper } from "../../../styled/paper";

const validationSchema = Yup.object({
    idArt: Yup.mixed().nullable(),
    cuit: Yup.string().nullable(),
    razonSocial: Yup.string().nullable(),
}).test(
    "at-least-one-filter",
    "Debe especificar ART o CUIT/Razón Social para buscar.",
    function validateAtLeastOneFilter(values) {
        const hasAnyFilter = Boolean(values?.idArt || values?.cuit?.trim() || values?.razonSocial?.trim());
        return hasAnyFilter || this.createError({ path: "cuit", message: "Debe especificar ART o CUIT/Razón Social para buscar." });
    },
);

const DatacenterPrestadoresSearch = ({
    initialValues,
    artOptions,
    onSearch,
    onReset,
}) => {
    return (
        <StyledPaper.Container>
            <FormikForm
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSearch}
            >
                {({ handleSubmit, setFieldValue }) => (
                    <>
                        <Form>
                            <StyledForm.Input>
                                <FormikAutocomplete
                                    options={artOptions}
                                    name="idArt"
                                    label="ART"
                                    variant="standard"
                                />
                            </StyledForm.Input>

                            <StyledForm.Input>
                                <FormikTextField
                                    name="cuit"
                                    label="CUIT"
                                    variant="standard"
                                />
                            </StyledForm.Input>

                            <StyledForm.Input>
                                <FormikTextField
                                    name="razonSocial"
                                    label="Razón Social"
                                    variant="standard"
                                />
                            </StyledForm.Input>
                        </Form>

                        <StyledForm.ButtonContainer>
                            <StyledForm.Button
                                variant="contained"
                                type="submit"
                                color="primary"
                                onClick={handleSubmit}
                            >
                                Buscar
                            </StyledForm.Button>
                        </StyledForm.ButtonContainer>

                        <StyledForm.ButtonContainer>
                            <StyledForm.Button
                                variant="contained"
                                type="reset"
                                color="primary"
                                onClick={() => {
                                    setFieldValue("idArt", initialValues.idArt);
                                    setFieldValue("cuit", initialValues.cuit);
                                    setFieldValue("razonSocial", initialValues.razonSocial);
                                    onReset();
                                }}
                            >
                                Limpiar
                            </StyledForm.Button>
                        </StyledForm.ButtonContainer>
                    </>
                )}
            </FormikForm>
        </StyledPaper.Container>
    );
};

export default DatacenterPrestadoresSearch;